export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--close.7016e4eb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};